<app-alert-toast></app-alert-toast>
<app-spinner *ngIf="isLoading"></app-spinner>
<router-outlet></router-outlet>
<app-footer></app-footer>